import * as React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

interface Props {
  title?: React.ReactNode
  tooltip?: React.ReactNode
  btnDisabled?: boolean
  btnText?: string
  btnLoading?: boolean
  btnHidden?: boolean
  className?: string
  children?: React.ReactNode
  btnOnClick?: () => void
}

export default function CastingStepComponent ({ title, tooltip, children, btnText, btnDisabled, btnLoading, btnHidden, btnOnClick, className }: Props) {
  return <TransitionGroup>
    <CSSTransition classNames="castingStep-anim" timeout={{ enter: 500, exit: 500 }} appear exit={ false }>
      <div className={ `castingStep-block ${ className || '' } ` }>
        <div className="castingStep-container">
          <div className="castingStep">
            <div className="castingStep-innerTop">
              { title && <div className="castingStep-title txtS">{ title }</div> }
              { children }
            </div>

            { !btnHidden && <div className="castingStep-innerBottom">
              <div className="buttonContainer--centered">
                <button
                  className={ `js-test-casting-step-submit button button--main is-pulse u-mtm ${btnDisabled ? 'play' : ''}` }
                  disabled={ btnDisabled || btnLoading }
                  onClick={ btnOnClick }>
                  { btnLoading && <div className="loaderClock"><div className="loaderClock-inner" /></div> }{ btnText }
                </button>
              </div>
            </div> }
          </div>
        </div>

        <div className="castingStepTooltip-container">{ tooltip }</div>
      </div>
    </CSSTransition>
  </TransitionGroup>
}
